import { observer } from "mobx-react-lite";
import { ShippingLabelSettingsStore } from "../../../../stores/shipping-label-settings-store";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { AUTO_SELECT_OPTION } from "../../../../constants";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";

interface IConnectionSettingsFieldsProps {
    shippingLabelStore?: ShippingLabelSettingsStore;
    validationGroup: IValidationGroup;
}

const ConnectionSettingsFields: React.FC<IConnectionSettingsFieldsProps> = observer(({shippingLabelStore, validationGroup}: IConnectionSettingsFieldsProps) => {

    const defaultCarrierSelectorStore = shippingLabelStore?.defaultCarrierSelectorStore;
    if (!defaultCarrierSelectorStore) {
        return null;
    }
    const carriersList = defaultCarrierSelectorStore.carriersList as IOption[];
    const selectedCarrier = () => {
        const carrierCode = defaultCarrierSelectorStore.carrierCode;
        if (!carrierCode) {
            return undefined;
        }
        const selectedOption = carriersList?.find( carrier => carrier.value === carrierCode);
        return selectedOption;
    }

    const serviceLevelList = defaultCarrierSelectorStore.serviceLevelList  as IOption[];
    const selectedService = () => {
        const serviceCode = defaultCarrierSelectorStore.serviceCode;
        if (!serviceCode) {
            return undefined;
        }
        const selectedOption = serviceLevelList?.find(service => service.value === serviceCode);
        return selectedOption;
    }

    const packageList = defaultCarrierSelectorStore.packagesList as IOption[];
    const selectedPakage = () => {
        const packageCode = defaultCarrierSelectorStore.packageCode;
        if (!packageCode) {
            return undefined;
        }
        const selectedOption = packageList?.find(pack => pack.value === packageCode);
        return selectedOption;
    }

    return (
        <>
            {!!shippingLabelStore?.showCarriersField() &&
                <FormFieldLine
                    label="Carrier"
                    note="Carrier to use for return labels."
                    required={!!shippingLabelStore?.aggregatorCode}
                >
                    <SelectDropdown
                        value={selectedCarrier()}
                        options={carriersList}
                        onChange={(v) => {defaultCarrierSelectorStore.setCarrierCode(v?.value as string)}}
                        isLoading={defaultCarrierSelectorStore.isCarriersListLoading}
                        disabled={carriersList.length === 1}
                        required={!!shippingLabelStore?.aggregatorCode}
                        validationGroup={validationGroup}
                    />
                </FormFieldLine>
            }
            <FormFieldLine
                label="Service Level"
                note="The service level to use for return labels."
                required={!!shippingLabelStore?.aggregatorCode}
            >
                <SelectDropdown
                    value={selectedService()}
                    options={serviceLevelList}
                    onChange={(v)=>{defaultCarrierSelectorStore.setServiceCode(v?.value as string)}}
                    disabled={selectedCarrier()?.value === AUTO_SELECT_OPTION || serviceLevelList.length === 1}
                    isLoading={defaultCarrierSelectorStore.isServicesListLoading}
                    required={!!shippingLabelStore?.aggregatorCode}
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            {!defaultCarrierSelectorStore.shouldSetDefaultPackageCode() &&
                <FormFieldLine
                label="Package"
                note="The package type to use for return labels."
                required={!!shippingLabelStore?.aggregatorCode}
            >
                <SelectDropdown
                    value={selectedPakage()}
                    options={packageList}
                    onChange={(v)=>{defaultCarrierSelectorStore.setPackageCode(v?.value as string)}}
                    isLoading={defaultCarrierSelectorStore.isPackagesListLoading}
                    required={!!shippingLabelStore?.aggregatorCode}
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            }
            
        </>
    )
})

export default ConnectionSettingsFields;